import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";
import * as ProgressBar from "progressbar.js"
import * as misc from "./utils/misc";
import {logger} from "./utils/Log";
//import {BchdRest} from "./bitcoin-cash/BchdRest";
import {TransferResponse} from "./structs/TransferResponse";


export class Transfer extends AbstractPage {
    protected checkLocalTransferTimerID: number = 0
    protected confirmed: boolean = false;
    protected transfer: TransferResponse = null; // the latest payment status from API

    constructor(app: JqueryApp) {
        super(app);

        const config = this.app.getConfig();

        this.app.$(window).on("load", ($) => {
            //this.addButtonLinkClass();
            /*if (this.app.$(".pay-preloader").length > 0) {
                this.app.$(".pay-preloader").fadeOut("slow");
            }*/
            this.webHelpers.preloadImages(config.transfer.successPayImage, config.transfer.successPayImageFinal);
        });
        this.app.$(() => { // jQuery 3.0 "document.ready"
            this.addEventListeners();
            this.startTransferTimer();
            //const msg = new AppMessage("fooo msg test", "danger");
            //msg.display()

            /*
            setTimeout(() => {
                this.sendPaidFrameMessage(); // TODO debug code to show frame immediately as paid
            }, 500);*/
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected addEventListeners() {

    }

    protected startTransferTimer() {
        setTimeout(this.checkTransferStatusLocally.bind(this, true), this.app.getConfig().transfer.checkMs);
    }

    protected checkTransferStatusLocally(repeat = true) {
        this.askBackendForTransfer();

        // check if the frame has been removed & stop querying
        const config = this.app.getConfig();

        this.scheduleLocalTransferStatusCheck(repeat, 5*this.app.getConfig().transfer.checkMs);

    }

    protected scheduleLocalTransferStatusCheck(repeat: boolean, timeoutMs: number) {
        clearTimeout(this.checkLocalTransferTimerID); // ensure we don't run multiple timers
        this.checkLocalTransferTimerID = window.setTimeout(() => {
            this.checkTransferStatusLocally(repeat);
        }, timeoutMs);
    }

    protected askBackendForTransfer() {
        const url = /*window.location.protocol + window.location.host + */this.app.getConfig().pathTransfer + "/check";
        let params = {
            token: this.app.getConfig().transfer.token, // jQuery escapes if needed
            tx_id: this.app.getConfig().transfer.tx_id, // jQuery escapes if needed
        }
        this.webHelpers.getApi(url, params, (data) => {
            if (!data.transfer) {
                // thats fien transfer not yet started
                //logger.error("Invalid response on transfer check %o", data);
                return;
            }
            this.transfer = TransferResponse.fromJson(data.transfer);
            logger.verbose("transfer update", this.transfer);

            const config = this.app.getConfig();
            const tr = this.app.getTr();

            // update confirmation count
            this.app.$("#transfer-status").text(this.transfer.status == "COMPLETED" ? tr.get("transferCompleted") : tr.get("transferPending"));

            if(this.transfer.status == "COMPLETED") {
                clearTimeout(this.checkLocalTransferTimerID); // ensure we don't run multiple timers


                let successImage = window.document.createElement("img");
                successImage.src = config.transfer.successPayImage;
                successImage.alt = tr.get("paid");
                successImage.id = "pay-success-image-animated";
                this.addSuccessImageProperties(successImage);
                setTimeout(() => {
                    this.showFinalPaidImage();
                }, 1300);

                this.app.$("#pay-payment-status").text(tr.get("paid"));
                this.app.$("#pay-payment-pending, #pay-payment-options, #pay-pay-instructions").fadeOut("slow");
                this.app.$("#pay-qr-code").replaceWith(successImage);

            }

        });
    }

    protected showFinalPaidImage() {
        const config = this.app.getConfig();
        //let successImageFinal: HTMLImageElement = Object.assign(this.slpPayments.window.document.createElement("img"), successImage); // doesn't copy attributes of native elements
        let successImageFinal = window.document.createElement("img");
        successImageFinal.src = config.transfer.successPayImageFinal;
        //successImageFinal.alt = this.slpPayments.getConfig().paidTxt;
        successImageFinal.id = "pay-success-image";
        this.addSuccessImageProperties(successImageFinal);
        this.app.$("#pay-success-image-animated, #pay-qr-code").replaceWith(successImageFinal);

        logger.verbose("Exchange done");

        // config.payment is undefined
        /*
        logger.verbose("Returning customer to URL: %s", config.payment.returnUrl);
        if (!config.payment.returnUrl || config.payment.returnUrl.toLowerCase().indexOf("http") !== 0)
            return;
        window.location.replace(config.payment.returnUrl);
         */
    }

    protected addSuccessImageProperties(image: HTMLImageElement) {
        image.style.maxWidth = "300px";
        image.style.maxHeight = "300px";
        image.style.width = "100%";
        image.style.display = "block";
        image.className = "pay-center";
    }

}
